$(document).ready(function () {
    var checkboxes = $("input:checked").length;
    if (checkboxes === 0) {
        $("#lcc-select-cards").attr("disabled", "disabled");
    }
    $(".lcc-select-cards-checkbox").click(function () {
        var n = $("input:checked").length;
        if (n === 0) {
            $("#lcc-select-cards").attr("disabled", "disabled");
        }
        else {
            $("#lcc-select-cards").removeAttr("disabled");
        }
    });

});
